export default function ApproveRequestModal({ onRemarksChange }) {
  return (
    <div>
      <div className="d-flex gap-2 align-items-center">
        <i class="bi bi-unlock-fill fs-4 text-primary"></i>
        <p className="fw-bold m-0" style={{ fontSize: "1.2rem" }}>
          Request Access
        </p>
      </div>
      <div>
        <p
          className="fw-medium"
          style={{ fontSize: ".875rem", paddingTop: "1.5rem" }}
        >
          Remarks
        </p>
        <textarea
          className="form-control"
          placeholder="Example"
          onChange={(e) => onRemarksChange(e.target.value, "approver_remarks")}
          style={{
            padding: ".7rem",
            maxHeight: "12rem",
            minHeight: "4rem",
            height: "8rem",
            fontSize: ".9rem",
          }}
        />
      </div>
    </div>
  );
}
